export const FACESHEET = 'face-sheet';
export const ASSOCIATED_FACILITIES = 'associated-facilities';
export const ADDRESS = 'address';
export const STREET = 'street';
export const STREET2 = 'street2';
export const CITY = 'city';
export const STATE = 'state';
export const ZIP = 'zip';
export const ASSOCIATED_FACILITY = 'associated-facility';
export const PHYSICIANS = 'physicians';
export const PHYSICIAN = 'physician';
export const CAREGIVERS = 'caregivers';
export const CAREGIVER = 'caregiver';
export const PATIENT_ASSIGNMENTS = 'patient-assignments';
export const ASSIGNED_PERSON = 'assigned-person';
export const PATIENT_CONDITION = 'patient-condition';
export const PATIENT_MEDICATIONS = 'patient-medications';
export const MEDICATIONS = 'medications';
export const MEDICATION = 'medication';
export const PROGRAM_SITE_NAME = 'program-site-name';
export const FIRST_NAME = 'first-name';
export const LAST_NAME = 'last-name';
export const FUNDING_SOURCES = 'funding-sources';
export const FUNDING_SOURCE = 'funding-source';
export const REFERRAL_SOURCE = 'referral-source';
export const SOURCE = 'source';
export const REFERRAL_TAKEN_BY = 'referral-taken-by';
export const CALLING_PERSON = 'calling-person';
export const CRM = 'crm';
export const REFERRAL_TAKEN_ON = 'referral-taken-on';
export const PAYER_NAME = 'payer-name';
export const POLICY_NUMBER = 'policy-number';
export const AT_RISK = 'at-risk';
export const ROOM_NUMBER = 'room-number';
export const ADMITTED_ON = 'admitted-on';
export const DISCHARGED_ON = 'discharged-on';
export const DISCHARGE_REASON = 'discharge-reason';
export const MARITAL_STATUS = 'marital-status';
export const PHONES = 'phones';
export const PHONE = 'phone';
export const NUMBER = 'number';
export const CAREGIVER_ROLES = 'caregiver-roles';
export const CAREGIVER_ROLE = 'caregiver-role';
export const MED_DESCRIPTION = 'med-description';
export const MED_INSTRUCTIONS = 'med-instructions';
export const MED_DOSE = 'med-dose';
export const MED_PRESCRIPTION = 'med-prescription';
export const MED_START_DATE = 'med-startdate';
export const MED_STOP_DATE = 'med-stopdate';
export const PATIENT_GREATEST_NEED = 'patient-greatest-need';
export const CAUSE_OF_STRESS = 'cause-of-stress';
export const BY_PATIENT = 'by-patient';
export const BY_FAMILY = 'by-family';
export const PHYSICAL_COND = 'physical-cond';
export const EMOTIONAL_COND = 'emotional-cond';
export const PROGNOSIS_AWARENESS = 'prognosis-awareness';
export const DIAGNOSIS_AWARENESS = 'diagnosis-awareness';
export const TYPE = 'type';
export const AREA_CODE = 'area_code';
export const RACE = 'race';
export const ETHNICITY = 'ethnicity';